import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { validatePassword } from '../../utils/passwordValidator';

const PasswordRequirements = ({ password = '', className = '' }) => {
  const { t } = useTranslation();
  const { checks } = validatePassword(password);

  const requirements = [
    {
      id: 'minLength',
      label: t('passwordValidation.minLength', 'Au moins 8 caractères'),
      valid: checks.minLength
    },
    {
      id: 'uppercase',
      label: t('passwordValidation.uppercase', 'Au moins une lettre majuscule (A-Z)'),
      valid: checks.hasUppercase
    },
    {
      id: 'lowercase',
      label: t('passwordValidation.lowercase', 'Au moins une lettre minuscule (a-z)'),
      valid: checks.hasLowercase
    },
    {
      id: 'number',
      label: t('passwordValidation.number', 'Au moins un chiffre (0-9)'),
      valid: checks.hasNumber
    },
    {
      id: 'symbol',
      label: t('passwordValidation.symbol', 'Au moins un symbole spécial (!@#$...)'),
      valid: checks.hasSymbol
    }
  ];

  return (
    <div className={`mt-2 p-3 bg-slate-50 dark:bg-slate-800/60 rounded-lg border border-slate-200 dark:border-slate-700/60 text-xs ${className}`}>
      <p className="font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
        {t('passwordValidation.title', 'Exigences du mot de passe :')}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
        {requirements.map((req) => (
          <div
            key={req.id}
            className={`flex items-center gap-1.5 transition-colors duration-150 ${
              req.valid
                ? 'text-emerald-600 dark:text-emerald-400 font-medium'
                : 'text-slate-500 dark:text-slate-400'
            }`}
          >
            {req.valid ? (
              <Check className="w-3.5 h-3.5 text-emerald-500 shrink-0" />
            ) : (
              <X className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500 shrink-0" />
            )}
            <span>{req.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordRequirements;
